import { useTranslation } from "react-i18next";
import { getEdgeClass } from "../../utils";
import SVGSelector from "../common-components/SVGSelector";
import { useSelector } from "react-redux";
import CustomModal from "../common-components/CustomModal";
import OrderVehicleFromBMWAGModalContent from "../OrderVehicleFromBMWAGModalContent";
import { useState } from "react";

const OrderVehicleFromBMWButton = ({
  isOrderVehicleFromBMWAG,
  btnTitle,
  btnClass,
  svgStrokeWidth,
}) => {
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const handleModalToggle = () => {
    setIsModalVisible(!isModalVisible);
  };
  const { edge = false } = useSelector((state) => state.uiConfig);
  return (
    <>
      {isOrderVehicleFromBMWAG ? (
        <span
          className={`${getEdgeClass(edge, "rounded-2xl")} border border-[var(--primary-dark-color)] bg-[var(--primary-dark-color)] font-bold text-[var(--text-white-black)] flex items-center justify-center text-[0.61rem] uppercase px-2 py-[4px] h-auto tracking-[-0.5px] whitespace-nowrap ${btnClass} cursor-default`}
        >
          {btnTitle}
          <span
            title={t(
              "/vehicles.Click here for more info on BMW order vehicles",
            )}
            className="flex items-center"
          >
            <sup className="top-[-0.7em]">
              <SVGSelector
                name="i-info-svg"
                onClick={(evt) => {
                  evt.preventDefault();
                  evt.stopPropagation();
                  handleModalToggle();
                }}
                strokeWidth={svgStrokeWidth}
              />
            </sup>
          </span>
        </span>
      ) : null}
      {isModalVisible && (
        <CustomModal
          isVisible={isModalVisible}
          handleModalToggle={handleModalToggle}
          modalHeader={t("/vehicles.Order vehicle from BMW AG")}
          modalContent={<OrderVehicleFromBMWAGModalContent />}
          height="h-[80vh]"
        />
      )}
    </>
  );
};
export default OrderVehicleFromBMWButton;
